import React from 'react';
import { Sparkles, PartyPopper } from 'lucide-react';

interface AtomBubbleProps {
  msg: string;
  kind?: 'standard' | 'celebration' | 'urgent';
  className?: string;
}

export function AtomBubble({ msg, kind = 'standard', className = '' }: AtomBubbleProps) {
  const Icon = kind === 'celebration' ? PartyPopper : Sparkles;
  return (
    <div className={`atom-bubble ${kind} ${className}`}>
      <div className="face">
        <Icon size={18} strokeWidth={2.4} />
      </div>
      <div className="bubble">{msg}</div>
    </div>
  );
}
